<template>
  <v-footer class="elson-footer" padless>
    <v-container class="footer-wrap py-10">
      <v-row align="start">
        <v-col cols="12" md="4">
          <span class="brand">ELSONIII</span>
          <p class="desc mt-3">
            ห้างหุ้นส่วนจำกัด เชียงรายมหานคร<br />
            ที่อยู่: 1 อาคารเอ็มไพร์ ทาวเวอร์ ชั้นที่ 47 ยูนิต 4703<br />
            ถนนสาทรใต้ แขวงยานนาวา เขตสาทร กรุงเทพฯ 10120<br />
            เบอร์โทร: <a href="tel:021198493" class="link-accent">02-119-8493</a><br />
            อีเมล: <a href="mailto:universegod@elsonlll.com" class="link-accent">universegod@elsonlll.com</a>
          </p>
        </v-col>

        <v-col cols="12" sm="6" md="2">
          <h3 class="col-title">เมนู</h3>
          <ul class="links">
            <li><router-link to="/" class="link">หน้าแรก</router-link></li>
            <li><router-link to="/board" class="link">กระดานข่าว</router-link></li>
            <li><router-link to="/marketplace" class="link">ตลาดชุมชน</router-link></li>
            <li><router-link to="/register/seller" class="link">เปิดร้านค้า</router-link></li>
            <li><router-link to="/aboutus" class="link">เกี่ยวกับเรา</router-link></li>
          </ul>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <h3 class="col-title">บริการของเรา</h3>
          <ul class="links">
            <li><router-link to="/delivery" class="link">สินค้าเดลิเวอรี่</router-link></li>
            <li><router-link to="/marketplace" class="link">โปรโมชั่นพิเศษ</router-link></li>
            <li><router-link to="/contactus" class="link">ศูนย์ช่วยเหลือ</router-link></li>
            <li><router-link to="/contactus" class="link">คำถามที่พบบ่อย</router-link></li>
            <li><router-link to="/contactus" class="link">ติดต่อเรา</router-link></li>
          </ul>
        </v-col>

        <v-col cols="12" md="3">
          <h3 class="col-title">ติดตามเรา</h3>
          <div class="socials mt-3">
            <a href="https://www.facebook.com/profile.php?id=61591316310332" target="_blank" rel="noopener noreferrer" class="social" aria-label="Facebook"><v-icon size="20">mdi-facebook</v-icon></a>
            <a href="https://www.instagram.com/elsonlll_channel/" target="_blank" rel="noopener noreferrer" class="social" aria-label="Instagram"><v-icon size="20">mdi-instagram</v-icon></a>
            <a href="https://www.youtube.com/channel/UCYrw2k0eIWUJWbLYxrNb98w" target="_blank" rel="noopener noreferrer" class="social" aria-label="YouTube"><v-icon size="20">mdi-youtube</v-icon></a>
          </div>

          <!-- Platform Stats -->
          <div class="platform-stats mt-6">
            <h3 class="col-title mb-4">ชุมชนของเรา</h3>
            <div class="stat-row">
              <div class="stat-item">
                <v-icon size="18" class="stat-icon">mdi-account-group</v-icon>
                <div class="stat-text">
                  <span class="stat-value">{{ formatCount(stats.userCount) }}</span>
                  <span class="stat-label">ผู้ใช้งาน</span>
                </div>
              </div>
              <div class="stat-item">
                <v-icon size="18" class="stat-icon">mdi-store</v-icon>
                <div class="stat-text">
                  <span class="stat-value">{{ formatCount(stats.sellerCount) }}</span>
                  <span class="stat-label">ร้านค้า</span>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>

      <v-divider class="foot-divider my-8" />

      <v-row align="center" justify="space-between" class="legal">
        <span class="legal-copy">© {{ new Date().getFullYear() }} ELSONIII — สงวนลิขสิทธิ์</span>
        <div class="legal-links">
          <router-link to="/privacy" class="link">นโยบายความเป็นส่วนตัว</router-link>
          <span class="dot">•</span>
          <router-link to="/terms" class="link">ข้อกำหนดการใช้งาน</router-link>
          <span class="dot">•</span>
          <router-link to="/payment-terms" class="link">ข้อตกลงการชำระเงิน</router-link>
        </div>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import { getPlatformStatsApi } from "@/services/api/adminServices";

export default {
  name: "Footer",
  data() {
    return {
      stats: { userCount: 0, sellerCount: 0 },
    };
  },
  async created() {
    try {
      const res = await getPlatformStatsApi();
      this.stats = res.data;
    } catch (e) {
      // ไม่แสดง error ถ้าโหลด stats ไม่ได้
    }
  },
  methods: {
    formatCount(n) {
      if (!n) return "0";
      if (n >= 1000000) return (n / 1000000).toFixed(1).replace(/\.0$/, "") + "M+";
      if (n >= 1000) return (n / 1000).toFixed(1).replace(/\.0$/, "") + "k+";
      return n.toLocaleString();
    },
  },
};
</script>

<style scoped>
/* accent green — emerald ที่ balance กับส้มได้ดี */
:root { --green: #3DBE7A; }

.elson-footer {
  background: #F4811F !important;
  color: #ffffff;
}
.footer-wrap {
  max-width: min(1440px, 90vw);
  margin: 0 auto;
  font-family: "Noto Sans Thai", sans-serif;
  padding-inline: clamp(24px, 4vw, 64px);
}
.footer-wrap :deep(.v-row) {
  row-gap: 32px;
}

/* Brand — ขาว + เส้นเขียวขีดใต้ให้รู้สึก "มีเอกลักษณ์" */
.brand {
  font-size: clamp(22px, 1.6vw, 26px);
  font-weight: 800;
  color: #ffffff;
  font-family: "Kanit", "Noto Sans Thai", sans-serif;
  letter-spacing: 1px;
  display: inline-block;
  padding-bottom: 6px;
  border-bottom: 3px solid #3DBE7A;
}

/* Description */
.desc {
  color: rgba(255, 255, 255, 0.85);
  font-size: 13.5px;
  line-height: 1.9;
}

/* Accent links (phone, email) */
.link-accent {
  color: #ffffff;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.2s;
}
.link-accent:hover {
  color: #3DBE7A;
  text-decoration: underline;
}

/* Column titles — ขาว + เส้นเขียวด้านซ้ายเป็น visual marker */
.col-title {
  font-size: 13px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 14px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-family: "Noto Sans Thai", Arial, sans-serif;
  padding-left: 10px;
  border-left: 3px solid #3DBE7A;
}

/* Nav links */
.links {
  list-style: none;
  padding: 0;
  margin: 0;
}
.links li {
  margin-bottom: 10px;
}
.link {
  color: rgba(255, 255, 255, 0.8);
  font-size: 13.5px;
  text-decoration: none;
  transition: color 0.2s;
}
.link:hover {
  color: #3DBE7A;
}

/* Social icons — กรอบขาว hover เป็นเขียวเต็ม */
.socials {
  display: flex;
  gap: 10px;
}
.social {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  border: 1.5px solid rgba(255, 255, 255, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  transition: all 0.22s ease;
  text-decoration: none;
}
.social:hover {
  background: #3DBE7A;
  border-color: #3DBE7A;
  color: #ffffff;
  transform: translateY(-2px);
}
.social :deep(.v-icon) {
  color: inherit !important;
}

/* Divider */
.foot-divider {
  border-color: rgba(255, 255, 255, 0.2) !important;
}

/* Legal bar */
.legal {
  width: 100%;
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.65);
  flex-wrap: wrap;
  row-gap: 8px;
}
.legal-links {
  display: flex;
  align-items: center;
  gap: 10px;
}
.dot {
  color: rgba(255, 255, 255, 0.35);
}
.legal-copy {
  font-family: "Kanit", "Noto Sans Thai", sans-serif;
}

@media (max-width: 1440px) {
  .footer-wrap {
    max-width: 1200px;
    padding-inline: clamp(16px, 4vw, 40px);
  }
}
@media (max-width: 960px) {
  .legal {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
}
.stat-row {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.stat-item {
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  padding: 10px 14px;
}
.stat-icon {
  color: #3DBE7A !important;
  flex-shrink: 0;
}
.stat-text {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}
.stat-value {
  font-size: 18px;
  font-weight: 800;
  color: #ffffff;
  font-family: "Kanit", "Noto Sans Thai", sans-serif;
}
.stat-label {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.7);
  margin-top: 1px;
}

@media (max-width: 600px) {
  .brand {
    font-size: 20px;
  }
  .desc {
    font-size: 13px;
  }
}
</style>
